/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventVirtualPageLoadedV1
 */
export interface SDKEventVirtualPageLoadedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventVirtualPageLoadedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventVirtualPageLoadedV1
     */
    person_id?: string;
}



/**
 * Check if a given object implements the SDKEventVirtualPageLoadedV1 interface.
 */
export function instanceOfSDKEventVirtualPageLoadedV1(value: object): value is SDKEventVirtualPageLoadedV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    return true;
}

export function SDKEventVirtualPageLoadedV1FromJSON(json: any): SDKEventVirtualPageLoadedV1 {
    return SDKEventVirtualPageLoadedV1FromJSONTyped(json, false);
}

export function SDKEventVirtualPageLoadedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventVirtualPageLoadedV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
    };
}

export function SDKEventVirtualPageLoadedV1ToJSON(json: any): SDKEventVirtualPageLoadedV1 {
    return SDKEventVirtualPageLoadedV1ToJSONTyped(json, false);
}

export function SDKEventVirtualPageLoadedV1ToJSONTyped(value?: SDKEventVirtualPageLoadedV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
        'person_id': value['person_id'],
    };
}

